import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../login/auth.service';
import { Filter } from '../../../helpers/tableview';
import { AdForm } from '../../upload/adform';

@Injectable()
export class DevicesService {

    private headers: Headers;
    private url = environment.apiUrl;

    constructor(private http: Http, private authService: AuthService) {
      this.headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authService.getAuth().token})
    }

    public getDevices(filter: Filter): Promise<any> {
        return this.http
          .post(this.url+'/admin/devices', filter, {headers: this.headers})
          .toPromise()
          .then(res => { return {items: res.json().devices, total: res.json().total}})
          .catch(this.handleError);
    }

    public getMasterList(): Promise<Array<MasterDevice>> {
      return this.http
      .post(this.url+'/admin/master_devices', {}, {headers: this.headers})
      .toPromise()
      .then(res => res.json().devices as Array<MasterDevice>)
      .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
      console.error('An error occurred', error);
      return Promise.reject(error.json().error.message || error);
    }

    public sendPush(deviceID: number) {
      return this.http
          .post(this.url+'/admin/devices/'+deviceID+'/push', {}, {headers: this.headers})
          .toPromise()
          .then(res => res.json())
          .catch(this.handleError);
    }

    // API call for getting Ad by it's ID
    public getAdByID(adID: number): Promise<AdForm> {
      return this.http
        .get(this.url+'/admin/adsid/'+adID, {headers: this.headers})
        .toPromise()
        .then(res => res.json().ad)
        .catch(this.handleError);
    }

    public updateDevice(device: any): Promise<any> {
      return this.http
        .post(this.url+'/admin/devices/'+device.id, device, {headers: this.headers})
        .toPromise()
        .then(res => res.json().device)
        .catch(this.handleError);
    }
}


export enum DeviceStatus {
  all = 0,
  online
}

export enum DeviceType {
  all = 0, 
  moving,
  static
}

export class MasterDevice {
  public id: number
  public name: string
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/devices/devices.service.ts